import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ConsumerAdminActions } from "../../actions/consumer-admin.actions";
import { ConsumerRolesState } from "../../models/consumer-admin/consumer-roles.state";
import { VendorRolesState } from "../../models/vendor-admin/vendor-roles.state";

const initialState: VendorRolesState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerAdminActions.consumerRoles.getApi, (state) => ({ ...state, loading: true })),
	on(ConsumerAdminActions.consumerRoles.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type"),
		loading: false
	})),
	on(ConsumerAdminActions.consumerRoles.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function getConsumerRolesReducer(
	state: ConsumerRolesState | undefined,
	action: Action
): ConsumerRolesState {
	return reducer(state, action);
}
